import { Component, ViewChild, OnInit } from '@angular/core';
import { ImageCropperComponent, CropperSettings, Bounds } from 'ng2-img-cropper';
import { UserService, MessagesServices } from '../../api/';
import { ToastyService, ToastyConfig, ToastOptions } from 'ng2-toasty';
import { MdDialogRef } from '@angular/material';

@Component({
    selector: 'upload-picture-dialog',
    templateUrl: './upload-picture-dialog.html',
    styleUrls: ['./upload-picture-dialog.css']
})
export class UploadPictureDialog implements OnInit {
    data1: any;
    cropperSettings1: CropperSettings;
    @ViewChild('cropper', undefined) cropper: ImageCropperComponent;
    fileIsOver = false;
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    checkIfMobile: boolean = false;
    private loading: boolean = false;
    public onlineOffline: boolean = navigator.onLine;

    constructor(public dialogRef: MdDialogRef<UploadPictureDialog>, private sm: MessagesServices, private userService: UserService, private toastyService: ToastyService,
        private toastyConfig: ToastyConfig) {
        window.addEventListener('online', () => {this.onlineOffline = true;});
        window.addEventListener('offline', () => {this.onlineOffline = false;});

        this.cropperSettings1 = new CropperSettings();
        this.cropperSettings1.width = 175;
        this.cropperSettings1.height = 175;
        this.cropperSettings1.noFileInput = true;
        this.cropperSettings1.croppedWidth = 250;
        this.cropperSettings1.croppedHeight = 250;

        this.cropperSettings1.canvasWidth = 275;
        this.cropperSettings1.canvasHeight = 275;

        this.cropperSettings1.minWidth = 100;
        this.cropperSettings1.minHeight = 100;

        this.cropperSettings1.rounded = false;

        this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
        this.cropperSettings1.cropperDrawSettings.strokeWidth = 2;

        this.data1 = {};
        this.messages = this.sm.messags;
        this.setMessages();
    }

    ngOnInit() {
        if (screen.width < 641) {
            this.checkIfMobile = true;
            this.cropperSettings1 = new CropperSettings();
            this.cropperSettings1.width = 150;
            this.cropperSettings1.height = 150;
            this.cropperSettings1.noFileInput = true;
            this.cropperSettings1.croppedWidth = 150;
            this.cropperSettings1.croppedHeight = 150;

            this.cropperSettings1.canvasWidth = 150;
            this.cropperSettings1.canvasHeight = 150;

            this.cropperSettings1.minWidth = 100;
            this.cropperSettings1.minHeight = 100;

            this.cropperSettings1.rounded = false;

            this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
            this.cropperSettings1.cropperDrawSettings.strokeWidth = 2;
        }
    }

    /**
    * getting system messages
    **/
    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_IMAGE_UPLOADED_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                }
            }
        }
    }

    cropped(bounds: Bounds) {
    }

    fileChangeListener($event) {
        let image: any = new Image();
        let file: File = $event.target.files[0];
        let myReader: FileReader = new FileReader();
        let that = this;
        myReader.onloadend = function (loadEvent: any) {
            image.src = loadEvent.target.result;
            that.cropper.setImage(image);
        };
        myReader.readAsDataURL(file);
    }

    uploadAvatar() {
        if(this.data1.image) {
            this.loading = true;
            let image = this.data1.image.replace(/^data:image\/(png|jpeg);base64,/, '');
            if(this.onlineOffline) {
                this.userService.uploadAvatar(image).subscribe((res) => {
                    let toastOptions: ToastOptions = {
                        title: this.title1,
                        msg: 'Image Uploaded Successfully.',
                        showClose: true,
                        timeout: 2000,
                        theme: 'default'
                    };
                    this.toastyService.success(toastOptions);
                    this.loading = false;
                    this.dialogRef.close(false);
                }, (err) => {
                    console.log(err);
                });
            } else{
                this.loading = false;
                this.dialogRef.close(false);
            }
        }
    }

    public fileOver(fileIsOver: boolean): void {
        this.fileIsOver = fileIsOver;
    }

    public onFileDrop(file: File): void {
        let image: any = new Image();
        let myReader: FileReader = new FileReader();
        let that = this;
        myReader.onloadend = function (loadEvent: any) {
            image.src = loadEvent.target.result;
            that.cropper.setImage(image);
        };
        myReader.readAsDataURL(file);
    }
    
}



// WEBPACK FOOTER //
// ./src/app/dashboard/upload-picture-dialog/upload-picture-dialog.ts